<template>
    <router-view></router-view>
</template>
<script>
    export default {

    }

    export const admin = {
        data() {
            return {
                nav: [
                    {
                        name: this.t('Translator'),
                        icon: 'flag',
                        route: {name: 'adminTranslator', params: {page: 1}},
                    }, {
                        name: this.t('System notifications'),
                        icon: 'envelope',
                        route: {name: 'adminTemplateList', params: {type: 'mail', page: 1}},
                    }, {
                        name: this.t('Patient e-mails'),
                        icon: 'bell',
                        route: {name: 'adminTemplateList', params: {type: 'patientMail', page: 1}},
                    }, {
                        name: this.t('Patient text messages'),
                        icon: 'bell',
                        route: {name: 'adminTemplateList', params: {type: 'patientTextMessages', page: 1}},
                    }, {
                        name: this.t('Epicrisis'),
                        icon: 'file',
                        route: {name: 'epicrisisList', params: {page: 1}},
                    }, {
                        name: this.t('Login as'),
                        icon: 'lock',
                        route: {name: 'loginAs', params: {page: 1}},
                    }, {
                        name: this.t('Data exports'),
                        icon: 'database',
                        route: {name: 'dataExports',params: {page: 1}},
                    }
                    // ,{
                    //     name: this.t('Mails'),
                    //     icon: 'envelope',
                    //     route: {name: 'mailAdmin', params: {page: 1}},
                    // },
                ]
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/admin/Admin.vue